"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./polyfill");
//# sourceMappingURL=index.js.map